/**
 * This file contains utils for the Qualifying Questions experiment.
 * Once a winning variant is found, this file should be adjusted to reflect the winner.
 */
import { Degree_ProductVariant as DegreeVariant } from '__generated__/graphql-types';

/**
 * This should match the education levels from the User Profile here:
 * https://github.com/webedx-spark/infra-services/blob/b0421ffabed99bc8543b37f56152f92e23030f58/libs/models/src/main/scala/org/coursera/user/StandardProfileMigrator.scala#L341
 */
const EDUCATION_LEVEL_RANK_MAP = {
  highSchool: 4,
  bachelorsDegree: 8,
} as const;

export const isLearnerQualified = (learnerEducation?: number | null, productVariant?: string): boolean => {
  if (
    (productVariant === DegreeVariant.BachelorsDegree || productVariant === DegreeVariant.MastersDegree) &&
    learnerEducation
  ) {
    switch (productVariant) {
      case DegreeVariant.BachelorsDegree:
        return learnerEducation >= EDUCATION_LEVEL_RANK_MAP.highSchool;
      case DegreeVariant.MastersDegree:
        return learnerEducation >= EDUCATION_LEVEL_RANK_MAP.bachelorsDegree;
      default:
        return false;
    }
  } else {
    // We're not running this experiment on any other product types.
    return false;
  }
};
